
export const endpoints = {
    sendEmail: '/sendEmail',
}